const CryptoJS = require("crypto-js");

class UserService{
    /*@ngInject*/
    constructor(SessionService,EventService) {
        this.session = SessionService;
        this.event = EventService;
        this.user = this.defaultUser();
        this.validUser = false;

    }

    defaultUser(){
        return {
            name:null,
            studentId:null,
            classId:null,
            schoolId:null,
            appId:null,
            compete:null,
            levels:null
        };
    }
    getUser(){
        return this.user;
    }
    isValid(){
        return this.validUser;
    }
    loadUserFromObject(userObject){
        this.user = userObject;
        this.validUser=true;
        this.storeUser();
        this.event.broadcast('user:loaded');
    }

    loadUserFromSession(){
        let text = this.session.get('user',false);
        if(text === false) {
            this.user = this.defaultUser();
            return;
        }
        let bytes = CryptoJS.DES.decrypt(text,'keyboardingOnlineRacer');
        let user;
        try{
            user = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }catch(e){
            console.log(e);
            user = null;
        }
        if(user !== null){
            this.validUser = true;
            this.user = user;
            this.event.broadcast('user:loaded');
        }else{
            this.user = this.defaultUser();
        }

    }
    storeUser(){
        let cipher = CryptoJS.DES.encrypt(JSON.stringify(this.user),'keyboardingOnlineRacer');
        this.session.set('user',cipher.toString(),true);
    }

}

export default UserService;


// WEBPACK FOOTER //
// ./public/app/services/user.service.js